<div [ngSwitch]="type">
    <div *ngSwitchCase="'list'" class="loader-container list-container">
        <div class="loader header small"></div>
        <div class="list-item desktop" *ngFor="let item of [1,2,3,4,5]">
            <div class="loader icon"></div>
            <div class="loader medium date"></div>
            <div class="loader large number"></div>
            <div class="loader xsmall amount"></div>
        </div>
        <div class="list-item mobile" *ngFor="let item of [1,2,3,4,5]">
            <div class="loader icon"></div>
            <div class="info">
                <div class="loader xsmall date"></div>
                <div class="loader small number"></div>
            </div>
            <div class="loader xsmall amount"></div>
        </div>
    </div>

    <div *ngSwitchCase="'billing-card'" [ngClass]="{'loader-container': page === 'billing', 'loader-container-activity': page === 'line-details'}">
        <div *ngIf="page==='billing'" class="loader header small"></div>
        <div *ngIf="page==='line-details'" class="loader header small"></div>
        <div class="billing-card" [ngClass]="isAddonsCards ? 'add-padding' : ''">
            <div class="loader avatar" *ngIf="avatar"></div>
            <div class="details" [ngClass]="avatar ? 'with-avatar' : ''">
                <div class="loader medium"></div>
                <div class="loader xlarge"></div>
                <div class="loader small"></div>
                <div class="loader xsmall"></div>
            </div>
            <div class="loader pill"></div>
        </div>
    </div>

    <div *ngSwitchCase="'banner'">
        <div class="banner-card" [ngClass]="{ 'line-banner': lineBanner }">
            <div class="loader avatar"></div>
            <div class="details" [ngClass]="avatar ? 'with-avatar' : ''">
                <div class="loader medium"></div>
                <div class="loader xlarge"></div>
                <div class="loader small"></div>
                <div class="loader large" [ngClass]="{ 'hidden': lineBanner }"></div>
            </div>
            <div class="loader pill"></div>
        </div>
    </div>

    <div *ngSwitchCase="'statement'">
        <h2><div class="loader statement-header medium"></div></h2>
        <div class="statement-container">
            <div class="statement-summary">
                <div class="loader avatar"></div>
                <div class="loader medium"></div>
                <div class="loader large"></div>
                <div class="loader medium"></div>
            </div>
            <div class="statement-detail">
                <div *ngFor="let item of [1,2]">
                    <div class="statement-item">
                        <div class="header"></div>
                        <div class="items">
                            <div class="item" *ngFor="let item of [1,2,3]">
                                <div class="left-item">
                                    <div class="loader xsmall"></div>
                                    <div class="loader small"></div>
                                </div>
                                <div class="right-item">
                                    <div class="loader xsmall"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="statement-item">
                        <div class="header"></div>
                        <div class="items">
                            <div class="item">
                                <div class="left-item">
                                    <div class="loader large"></div>
                                    <div class="loader xlarge"></div>
                                </div>
                                <div class="right-item">
                                    <div class="loader xsmall"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'pastDue'" >
        <div class="over-due">
            <div class="loader icon"></div>
            <div class="loader small"></div>
        </div>
        <div class="past-due">
            <div class="loader xlarge"></div>
            <div class="loader medium"></div>
        </div>
    </div>

    <div *ngSwitchCase="'usage'"> <!-- TODO - Next release - Some more enhancement required -->
        <div class="name-section">
            <h2><div class="loader name-header medium"></div></h2>
        </div>
        <div class="usage-container">
            <div class="banner-card">
                <div class="details">
                    <div class="loader medium"></div>
                    <div class="loader xlarge"></div>
                    <div class="loader small"></div>
                    <div class="loader large"></div>
                </div>
                <div class="details">
                    <div class="loader medium"></div>
                    <div class="loader xlarge"></div>
                    <div class="loader small"></div>
                    <div class="loader large"></div>
                </div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'card'">
        <div class="name-section">
            <h2 class="card-header"><div class="loader name-header large"></div></h2>
        </div>
        <div>
            <div class="card-container">
                <div class="card" *ngFor="let item of [1,2]">
                    <div class="card-row">
                        <div class="name-icon loader xlarge"></div>
                        <div class="card-content">
                            <p class="loader xlarge"></p>
                            <p class="loader xlarge"></p>
                        </div>
                    </div>
                    <span class="desc loader large"></span>
                </div>
            </div>
        </div>
    </div>


    <!-- TODO - Next release - Default case for any other type -->

    <div *ngSwitchCase="'plan-data-options'">
        <div class="plan-details">
            <div class="info">
                <div class="info-icon">
                    <div class="loader large-icon"></div>
                </div>
                <div class="data">
                    <div class="loader small"></div>
                    <div class="loader large with-height"></div>
                    <div class="loader xlarge with-height"></div>
                </div>
                <div class="action">
                    <div class="inuse-icon small loader" role="status" aria-label="loading"></div>
                </div>
            </div>
            <div class="features">
                <div class="contents">
                    <div class="information">
                        <div class="info-icon">
                            <div class="loader medium-icon"></div>
                        </div>
                        <div class="data">
                            <div class="loader large"></div>
                            <div class="loader xlarge with-height"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="features">
                <div class="loader small"></div>
                <div class="contents">
                    <div class="information">
                        <div class="info-icon">
                            <div class="loader medium-icon"></div>
                        </div>
                        <div class="data">
                            <div class="loader large"></div>
                            <div class="loader xlarge with-height"></div>
                        </div>
                    </div>
                    <div class="cta">
                        <div class="loader pill"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="plan-details">
            <div class="info">
                <div class="info-icon">
                    <div class="loader large-icon"></div>
                </div>
                <div class="data">
                    <div class="loader small"></div>
                    <div class="loader large with-height"></div>
                    <div class="loader xlarge with-height"></div>
                </div>
            </div>
            <div class="features">
                <div class="loader small"></div>
                <div class="contents">
                    <div class="information">
                        <div class="info-icon">
                            <div class="loader medium-icon"></div>
                        </div>
                        <div class="data">
                            <div class="loader large"></div>
                            <div class="loader xlarge with-height"></div>
                        </div>
                    </div>
                    <div class="cta">
                        <div class="loader pill"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'gtpHeader'">
        <div class="gtp-header">
            <div class="header-row">
                <div class="loader medium"></div>
            </div>
            <div class="title">
                <div class="loader titlebar"></div>
                <div class="loader titlebar"></div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'gtpLine'">
        <div class="gtp-line-row">
            <div class="gtp-line">
                <div class="loader small"></div>
                <div class="loader small"></div>
            </div>
            <div class="gtp-details">
                <div class="loader xsmall"></div>
                <div class="loader xsmall"></div>
            </div>
        </div>
        <div class="gtp-line-row">
            <div class="gtp-line">
                <div class="loader small"></div>
                <div class="loader small"></div>
            </div>
            <div class="gtp-details">
                <div class="loader xsmall"></div>
                <div class="loader xsmall"></div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'order-summary'">
        <h2><div class="loader titlebar"></div></h2>
        <div class="container">
            <div class="device-header">
                <div class="loader xsmall"></div>
                <div class="loader xsmall"></div>
            </div>
            <div class="loader small"></div>
            <div class="plan-data">
                <div class="loader medium-icon"></div>
                <div class="loader xsmall"></div>
            </div>
            <div class="container">
                <div class="device-details">
                    <div class="device-image">
                        <div class="loader mobile-icon"></div>
                    </div>
                    <div class="device-data">
                        <div class="device-header">
                            <div class="loader xsmall"></div>
                            <div class="loader xsmall"></div>
                        </div>
                        <div class="loader medium"></div>
                        <div class="device-charges">
                            <div class="loader medium"></div>
                            <div class="loader large"></div>
                            <div class="loader xlarge"></div>
                            <div class="loader medium"></div>
                            <div class="loader xsmall"></div>
                        </div>    
                    </div>
                </div>    
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'billPreview-WhatsChanging'" class="container">
        <div class="device-header">
            <div class="loader medium"></div>
            <div class="loader xsmall"></div>
        </div>
        <div class="loader xlarge"></div>

        <div class="loader small"></div>
        <div class="loader medium"></div>

        <div class="loader small"></div>
        <div class="loader large"></div>
    </div> 
</div>
